<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />

                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-button class="item" icon="icon icon-jiarucopy" @click="on_create()" type="primary">新建</a-button>

                <!-- <a-button class="item" icon="icon icon-jiarucopy" @click="on_import()">导入</a-button> -->
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索联系人、电话或者QQ" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-spin tip="加载中" :spinning="loading">
                <div class="items">
                    <section class="item" v-for="item in data_source" :key="item.id">
                        <div class="user-name">
                            <div class="name">{{ item.contact_name }}</div>
                        </div>
                        <div class="user-info">
                            <div class="company">{{ item.company || "【无公司信息】" }}</div>
                            <div class="id">供应商ID：{{ item.id }}</div>
                            <!-- <div class="id">用户ID：{{ item.member_id }}</div> -->
                        </div>

                        <div class="contact">
                            <div class="mobile" v-if="item.contact_tel">
                                <i class="anticon anticon-icon icon-phone"></i>
                                {{ item.contact_tel }}
                            </div>
                            <div class="qq" v-if="item.contact_qq">
                                <a-icon type="icon icon-qq1"></a-icon>
                                {{ item.contact_qq }}
                            </div>
                            <div class="address" v-if="item.contact_address">
                                {{ item.contact_address }}
                            </div>
                        </div>
                        <div class="tm-count">
                            <div class="corner">商标数量</div>
                            <a :href="`/trademark/whole?_s=1&supplier_id=${item.id}`" target="_blank">{{ item.trademark_count || "" }}</a>
                        </div>
                        <div class="payment">
                            <div class="corner">付款方式</div>
                            <div class="payment-type">
                                {{ item.payment_type_text }}
                            </div>
                            <div class="payment-detail">
                                <template v-if="item.payment_no">
                                    <div v-if="item.payment_type === 'alipay'">
                                        <small>户名：{{ item.payment_account }}</small> <br />
                                        <small>账号：{{ item.payment_no }}</small>
                                    </div>
                                    <div v-if="item.payment_type === 'bank'">
                                        <small>开户行：{{ item.payment_name }}</small
                                        ><br /><small>户名：{{ item.payment_account }}</small
                                        ><br />
                                        <small>账号：{{ item.payment_no }}</small>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="remark">
                            <div class="content">
                                {{ item.remark }}
                            </div>
                            <div class="extra">
                                <a-tag color="blue" v-if="item.is_include_notary">包公证</a-tag>
                                <a-tag color="blue" v-if="item.is_include_transfer">包转让费</a-tag>
                                <a-tag color="blue" v-if="item.is_include_invoice">包开票</a-tag>
                            </div>
                        </div>
                        <div class="creater">
                            <div class="name">{{ item.user.name }}</div>
                            <div class="date">{{ moment(item.created_at * 1000).format("YYYY-MM-DD") }}</div>
                        </div>
                        <div class="action">
                            <a-button size="small" style="margin-right: 8px" @click="on_edit(item)">修改</a-button>
                            <a-button size="small" @click="on_import(item)">导入</a-button>
                            <a-button size="small" style="margin-right: 8px" @click="on_update(item)">更新</a-button>
<!--                          商标供应商里面把删除改成添加，意思是单独添加商标入库，售卖非我们自己的商标，都是确定好商标后单个加上去，添加字段注册号，分类号，价格，备注，api获取信息后入库。-->
                            <a-button size="small" @click="on_add(item.id)">添加</a-button>
<!--                            <a-button size="small" @click="on_delete(item)" style="margin-top:8px" type="danger">删除</a-button>-->
                        </div>
                    </section>
                </div>
            </a-spin>

            <!-- 分页 -->
            <div class="page" v-if="pagination && pagination.current > 0 && data_source.length">
                <div></div>
                <a-pagination
                    :disabled="loading"
                    v-model="pagination.current"
                    :total="pagination.total"
                    :page-size.sync="pagination.pageSize"
                    show-size-changer
                    showQuickJumper
                    :pageSizeOptions="['20', '50', '100', '200']"
                    @change="(page, pageSize) => on_pagination_change_common(page, pageSize)"
                    :show-total="(total, range) => `${range[0]}-${range[1]} , 展示 ${total} 条，实际 ${pagination.totalReality || '-'} 条`"
                />
            </div>
        </div>

        <!-- 新建供应商     -->
        <modal_create
            :visible="visible_create"
            @close="visible_create = false"
            :record="selected_record"
            :mode="mode_create"
            :callback="load"
        />

        <!-- 导入价格 -->
        <modal_import_price
            :visible="visible_import_price"
            @close="visible_import_price = false"
            :record="selected_record"
            :callback="load"
        />

      <!-- 添加供应商的商标     -->
      <modal_trademarket_create
          :visible="visible_modal_trademarket_create"
          @close="visible_modal_trademarket_create = false"
          :record="supplier_id"
          :callback="load"
      />
    </div>
</template>
<script>
    import modal_create from "./modal_create.vue";
    import modal_import_price from "./modal_import_price.vue";
    import modal_trademarket_create from "./modal_trademarket_create.vue";

    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    export default {
        components: { modal_create,
          modal_import_price,
          modal_trademarket_create
        },
        mixins: [common_pagination],
        data() {
            return {
                path: "/trademark/supplier",
                visible_create: false,
                visible_import_price: false,
              visible_modal_trademarket_create: false,
                mode_create: "create",
                selected_record: null,
                wd: null,
                data_source: [],
                loading: false,
              supplier_id: null,
            };
        },
        mounted() {
            this.load();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/trademark/supplier?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            //修改供应商
            on_edit(row) {
                this.selected_record = row;
                this.mode_create = "edit";
                this.visible_create = true;
            },
          //添加供应商
            on_create() {
                this.selected_record = {};
                this.visible_create = true;
                this.mode_create = "create";
            },
          //添加商标
          on_add(id){
            this.supplier_id = id;
            this.visible_modal_trademarket_create = true;
          },
          //删除供应商
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: "删除确认",
                    content: `是否删除【${record.contact_name}】`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete("/trademark/supplier/" + record.id)
                                .then((res) => {
                                    if (res.success) {
                                        this.$message.success(res.message);
                                        this.load();
                                    } else {
                                        this.$error({ title: "失败", content: res.message, centered: true });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
          //导入商标
            on_import(record) {
                this.visible_import_price = true;
                this.selected_record = record;
            },
          //重新更新这个代理商的已初审的商标资源，从api接口重新查询获取该商标的状态，看看有没有变为已注册
          on_update(record) {
            return new Promise((resolve, reject) => {
              this.$http
                  .delete("/trademark/supplier/" + record.id + '?type=update')
                  .then((res) => {
                    if (res.success) {
                      this.$message.success(res.message);
                      this.load();
                    } else {
                      this.$error({ title: "失败", content: res.message, centered: true });
                    }
                  })
                  .catch(() => {})
                  .then(() => {
                    resolve();
                  });
            }).catch();
          },
        },
    };
</script>
<style lang="less" scoped>
    .framework-body {
        .main {
            overflow-y: auto;
            position: absolute;
            top: 56px;
            left: 0;
            right: 0;
            bottom: 0;
            .items {
                min-height: 200px;
                .item {
                    border: 1px solid #e8e8e8;
                    margin: 16px;
                    border-radius: 5px;
                    overflow: hidden;
                    display: flex;
                    &:hover {
                        box-shadow: 0 6px 16px -8px #00000014, 0 9px 28px 0 #0000000d, 0 12px 48px 16px #00000008;
                    }
                    .corner {
                        position: absolute;
                        right: 0;
                        height: 24px;
                        background: #fafafa;
                        color: #00000073;
                        font-size: 12px;
                        text-align: center;
                        line-height: 24px;
                        top: 0;
                        padding: 0 4px;
                        font-weight: normal;
                    }
                    .user-name {
                        min-width: 110px;
                        max-width: 110px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        margin: 16px;
                        padding-right: 16px;
                        margin-right: 0;
                        .name {
                            font-size: 16px;
                            margin-bottom: 4px;
                        }
                        .id {
                            font-size: 12px;
                            color: #9e9e9e;
                        }
                    }
                    .user-info {
                        min-width: 200px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        margin-bottom: 4px;
                        padding: 16px;
                        .id {
                            font-size: 12px;
                            color: #9e9e9e;
                        }
                    }
                    .tm-count {
                        min-width: 80px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        font-size: 16px;
                        font-weight: bold;
                    }
                    .contact {
                        min-width: 200px;
                        border-right: 1px solid #efefef;
                        padding: 16px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        div {
                            margin-bottom: 4px;
                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                        .address {
                            font-size: 12px;
                            color: #9e9e9e;
                        }
                    }
                    .payment {
                        min-width: 200px;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        position: relative;
                    }
                    .remark {
                        width: 100%;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                    }
                    .creater {
                        min-width: 120px;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .date {
                            font-size: 12px;
                            color: #9e9e9e;
                        }
                    }
                    .action {
                        min-width: 140px;
                        padding: 16px;
                    }
                }
            }
            .page {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 16px;
                .tips {
                    font-size: 12px;
                    color: #9e9e9e;
                }
            }
        }
    }
</style>
